<template lang="pug">
  .generic-wrapper
    .container
      BackButton(name="StatisticsOverview")
      h1.title Kundenanalyse
      .sub-headline Hier erfahren Sie mehr über Ihre Kunden.

      .calendar-config.margin-top      
        b-field(group)
          b-field(label-position="on-border" label="Jahr")
            b-select(v-model="year")
              option(v-for="y in currentYear+10-rootYear") {{rootYear + y}}
          .spacer.md
          b-field(label-position="on-border" label="Monat")
            b-select(v-model="month")
              option(value="-1") Gesamt
              option(value="0") Januar
              option(value="1") Februar
              option(value="2") März
              option(value="3") April
              option(value="4") Mai
              option(value="5") Juni
              option(value="6") Juli
              option(value="7") August
              option(value="8") September
              option(value="9") Oktober
              option(value="10") November
              option(value="11") Dezember
          .spacer.md
          b-field(label-position="on-border" label="Datenpool")
            b-select(v-model="dataPool")
              option(value="7,8,9,10") Nur AGV
              option(value="11,12,13,15") Nicht AGV
              option(value="7,8,9,10,11,12,13,15") Gesamt


      .stats
        .card.margin-top
          .top
            .left
              .card-headline Top 10 Postleitzahlen (1-stellig)
              .zip-codes
                .zip-code(v-for="zip in stats.top10ZipCodesOneLetter")
                  .text(:style="{background: getBackgroundColor(zip[1])}" @click="getZipCodeForPartialZip(zip[0])") {{zip[0]}} <span>x{{zip[1]}}</span>
              
              .card-headline Top 10 Postleitzahlen (2-stellig)
              .zip-codes
                .zip-code(v-for="zip in stats.top10ZipCodesTwoLetter")
                  .text(:style="{background: getBackgroundColor(zip[1])}" @click="getZipCodeForPartialZip(zip[0])") {{zip[0]}} <span>x{{zip[1]}}</span>
              
              .card-headline So haben die Gäste gebucht
              .zip-codes
                .zip-code(v-for="zip in stats.topReferrals")
                  .text() {{zip[0] === 'null' ? 'Unbekannt' : zip[0]}} <span>x{{zip[1]}}</span>
            .grid
              .card.margin-top.border
                .top
                  .left
                    .card-headline Anzahl Buchungen
                  .right
                  .big-number {{ stats.totalBookings }}
              .card.margin-top.border
                .top
                  .left
                    .card-headline Durchschnittliche Buchungswert
                  .right
                  .big-number {{ stats.averageBookingValue }}
              .card.margin-top.border
                .top
                  .left
                    .card-headline Durchschnittliche Aufenthaltsdauer
                  .right
                  .big-number {{ stats.averageStayDuration }} Tage
              .card.margin-top.border
                .top
                  .left
                    .card-headline Durchschnittliche Buchungsvorlaufzeit
                  .right
                  .big-number {{ stats.averageBookingLeadTime }} Tage
  
  </template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      ownerFilter: [7, 8, 9, 10],
      stats: {
        averageBookingValue: 0,
        averageStayDuration: 0,
        averageCancellationRate: 0,
        averageBookingLeadTime: 0,
        top10ZipCodesTwoLetter: [],
        top10ZipCodesOneLetter: [],
        totalBookings: 0
      },
      customers: [],
      summary: {
        arrivalCount: 0,
        arrivals: [],
        bookingItems: [],
        payments: [],
      },
      dataPool: "7,8,9,10",
      rootYear: new Date().getFullYear() - 10,
      currentYear: new Date().getFullYear(),
      year: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      month: -1,
      months: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ]
    };
  },
  computed: {
    startDate() {
      return DateTime.fromObject({ year: this.year, month: this.month == -1 ? 1 : +this.month + 1, day: 1 });
    },
    endDate() {
      return DateTime.fromObject({ year: this.year, month: this.month == -1 ? 12 : +this.month + 1, day: 1 }).endOf('month');
    },
  },
  watch: {
    dataPool() {
      this.ownerFilter = this.dataPool.split(",").map(Number);
      this.init();
    },
    async year() {
      this.init();
    },
    async month() {
      this.init();
    },
  },
  async mounted() {
    this.$store.dispatch("rentObjects/findAll");
    this.init();
  },
  methods: {
    getZipCodeForPartialZip(zip) {
      const zipCodes = this.customers.map(c => c.address.zip);
      const zipLetterCount = zip.length;
      const zipCode = zipCodes.filter(z => z && z.slice(0, zipLetterCount) === zip);
      if (zipCode.length === 0) {
        return;
      }
      this.openMapWithZipCode(zipCode[0]);
    },
    openMapWithZipCode(zip) {
      window.open(`https://nominatim.openstreetmap.org/ui/search.html?q=${zip}+germany`, '_blank');
    },
    async init() {
      const loadingComponent = this.$buefy.loading.open();
      this.summary = await this.$store.dispatch("rentObjectBookings/findBookingItems", { start: this.startDate, end: this.endDate, filter: this.ownerFilter });
      this.customers = await this.$store.dispatch("customers/findAll");
      this.stats = this.calculateStats();
      loadingComponent.close();
    },
    getBackgroundColor(value) {
      // get a color between green, yellow and red based on the number value and total value
      const total = this.stats.totalBookings;
      const percentage = value / total;

      if (percentage < 0.05) {
        return "rgb(245 158 11)"; // yellow
      } else {
        return "rgb(34 197 94)"; // green
      }
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yy")
    },
    toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    calculateStats() {
      let totalBookings = 0;
      const zipCodeCounter = {
        zipCodesTwoLetter: Object.fromEntries(Array.from({ length: 100 }, (_, i) => [i.toString().padStart(2, '0'), 0])),
        zipCodesOneLetter: Object.fromEntries(Array.from({ length: 10 }, (_, i) => [i.toString(), 0])),
      }

      const createdDaysBeforeArrival = [];
      const bookingValues = [];
      const arrivalDepartureDurations = [];
      const topReferrals = {};
      
      // first we loop through all arrivals
      for (const booking of this.summary.arrivals) {
        const customer = this.customers.find(c => c.id === booking.customerId);
        if (!customer) {
          continue;
        }
        const bookingItems = this.summary.bookingItems.filter(bi => bi.rentObjectBookingId === booking.id);
        if (bookingItems.length === 0) {
          alert("Booking items not found");
          continue;
        }
        bookingValues.push(bookingItems.reduce((total, bi) => total + bi.totalPrice, 0));
        const createdAt = new Date(bookingItems[0].createdAt);
        createdDaysBeforeArrival.push(Math.floor((new Date(booking.startDate) - createdAt) / (1000 * 60 * 60 * 24)));
        arrivalDepartureDurations.push(Math.floor((new Date(booking.endDate) - new Date(booking.startDate)) / (1000 * 60 * 60 * 24)));
        const twoLetterZipCode = customer.address.zip.slice(0, 2);
        zipCodeCounter.zipCodesTwoLetter[twoLetterZipCode]++;
        zipCodeCounter.zipCodesOneLetter[twoLetterZipCode[0]]++;

        // topReferrals
        if (!topReferrals[booking.referral]) {
          topReferrals[booking.referral] = 1;
        } else {
          topReferrals[booking.referral] = topReferrals[booking.referral] + 1;
        }

        totalBookings++;
      }
      return {
        averageBookingValue: this.toCurrency(Math.round(bookingValues.reduce((total, value) => total + value, 0) / bookingValues.length / 100)),
        averageStayDuration: Math.round(arrivalDepartureDurations.reduce((total, value) => total + value, 0) / arrivalDepartureDurations.length),
        averageCancellationRate: this.summary.arrivals.reduce((total, arrival) => total + arrival.cancellationRate, 0) / this.summary.arrivals.length,
        averageBookingLeadTime: Math.round(createdDaysBeforeArrival.reduce((total, value) => total + value, 0) / createdDaysBeforeArrival.length),
        top10ZipCodesTwoLetter: Object.entries(zipCodeCounter.zipCodesTwoLetter).sort((a, b) => b[1] - a[1]).slice(0, 10),
        top10ZipCodesOneLetter: Object.entries(zipCodeCounter.zipCodesOneLetter).sort((a, b) => b[1] - a[1]).slice(0, 10),
        totalBookings,
        topReferrals: Object.entries(topReferrals).sort((a, b) => b[1] - a[1])
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.big-number {
  font-size: 2rem;
  font-weight: 600;

  span {
    color: lightgray;
    margin-left: 24px;
  }
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.border {
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.zip-codes {
  display: flex;
  flex-wrap: wrap;
  .zip-code {
    display: flex;
    align-items: center;
    margin-right: 16px;
    margin-bottom: 16px;
    svg {
      margin-right: 8px;
    }
    .text {
      padding: 2px 5px;
      display: flex;
      align-items: center;
      font-weight: 500;
      border-radius: 3px;
      background: rgb(241 245 249);
      span {
        font-size: 14px;
        padding: 4px 8px;
        border-radius: 4px;
        margin-left: 8px;
      }
    }
  }
}
</style>